<template>
    <div>
        <b-button
            id="buttonComments"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-dark"
            class="btn-icon rounded-circle"
            v-b-tooltip.hover.on.v-dark
            title="COMENTARIOS"
            @click="getComments()"
        >
            <feather-icon icon="MessageSquareIcon" />
        </b-button>
        
        <b-modal
            ref="modal"
            :id="`modal-${identifier}`"
            centered
            size="lg"
            :title="title"
            modal-class="modal-primary"
            no-close-on-backdrop
            no-close-on-esc
        >            
           <b-form-textarea
                id="textarea"            
                placeholder="Ingrese comentarios ..."
                v-model="commentsModal"
                class="my-2"
                rows="5"
            >                
            </b-form-textarea>

            <template #modal-footer>

                <b-button
                    variant="primary"
                    class="float-right"
                    @click="updateComments()"
                >
                    GUARDAR
                </b-button>

                <b-button variant="outline-danger" @click="cancelar()">
                    CANCELAR
                </b-button>
            </template>
        </b-modal>
        
    </div>
</template>

<script>

    import { ref } from '@vue/composition-api';
    import Ripple from 'vue-ripple-directive';

    export default {
        props: {
            comments: String,
            identifier: Number,
            title: String       
        },
        directives: {
            Ripple
        },
        setup(props, { emit }) {

            // REFS
            const commentsModal = ref(props.comments);
            const modal = ref(null);

            const getComments = () => {     
                commentsModal.value = props.comments;
                modal.value.show();
            };

            const updateComments = () => {
                const data = {
                    comments : commentsModal.value,
                    identifier: props.identifier
                }

                emit('update-comments', data);
                modal.value.hide();
            };

            const cancelar = () => {
                commentsModal.value = null;
                modal.value.hide();
            };

            return {
                // DATA
                commentsModal,

                // REFS
                modal,

                // METHODS
                getComments,
                updateComments,
                cancelar
            }
        }
    }

</script>